var map = {
	"./template-1/common/client-details-dialog": "app/styles/client/templates/template-1/common/client-details-dialog",
	"./template-10/common/client-details-dialog": "app/styles/client/templates/template-10/common/client-details-dialog",
	"./template-11/common/client-details-dialog": "app/styles/client/templates/template-11/common/client-details-dialog",
	"./template-2/common/client-details-dialog": "app/styles/client/templates/template-2/common/client-details-dialog",
	"./template-3/common/client-details-dialog": "app/styles/client/templates/template-3/common/client-details-dialog",
	"./template-4/common/client-details-dialog": "app/styles/client/templates/template-4/common/client-details-dialog",
	"./template-5/common/client-details-dialog": "app/styles/client/templates/template-5/common/client-details-dialog",
	"./template-6/common/client-details-dialog": "app/styles/client/templates/template-6/common/client-details-dialog",
	"./template-7/common/client-details-dialog": "app/styles/client/templates/template-7/common/client-details-dialog",
	"./template-8/common/client-details-dialog": "app/styles/client/templates/template-8/common/client-details-dialog",
	"./template-9/common/client-details-dialog": "app/styles/client/templates/template-9/common/client-details-dialog"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9257;